import React from "react";
import { useTheme } from "styled-components";

import { RemoteComponentWrapper } from "./RemoteComponentWrapper";

const RemoteForgeNarrativeDownloadButton = React.lazy(
    () => import("adsForgeMfc/NarrativeDownloadButton"),
) as React.FC<any>;

export const ForgeNarrativeDownloadButton: React.FC<any> = (props) => {
    const theme = useTheme();

    return (
        <RemoteComponentWrapper>
            <RemoteForgeNarrativeDownloadButton {...props} theme={theme} />
        </RemoteComponentWrapper>
    );
};
